module.exports = __webpack_public_path__ + "static/media/map-groene-gordel-leuven.eb022036.png";